import { useState } from 'react'
import { useNotification } from 'components/notification/useNotification'
import useAuth from 'hooks/useAuth'
import { useQuery } from 'react-query'
import { get } from 'utils'
import { FIRST_DAY } from 'utils/catalogs'
import { formatDate } from 'utils/index'
import { GetPaymetsGraph } from '../../../api/index'
import { PaymetsGraph } from '../Types/DashboardTypes'

export default function usePaymentsGraph() {
  const { user } = useAuth()

  const date = Date.now()

  const { onNotify } = useNotification()
  const [dataPayment, setDataPayment] = useState<PaymetsGraph>(
    {} as PaymetsGraph
  )
  const [initialDatePayment, setInitialDatePayment] = useState<any>(
    formatDate(FIRST_DAY, 'yyyy-MM-dd')
  )

  const [endDatePayment, setEndDatePayment] = useState<any>(
    formatDate(new Date(date), 'yyyy-MM-dd')
  )

  const { isLoading, refetch } = useQuery(
    'GET_PAYMENTS_BY_DATE',
    () =>
      GetPaymetsGraph(
        user.id,
        formatDate(new Date(initialDatePayment), 'yyyy-MM-dd'),
        formatDate(new Date(endDatePayment), 'yyyy-MM-dd')
      ),
    {
      onSuccess: data => {
        setDataPayment(data.data)
      },
      onError: error => {
        const errorMessage = get(
          error,
          'response.data.errors.detail',
          'An error occurred'
        )
        onNotify({ severity: 'error', message: errorMessage })
      }
    }
  )
  const onGetDataPayment = () => refetch()

  return {
    isLoading: isLoading,
    dataPayment,
    initialDatePayment,
    endDatePayment,
    open,
    setInitialDatePayment,
    setEndDatePayment,
    onGetDataPayment
    //onToggleTemplate,
    //isSent
  }
}
